import { render, staticRenderFns } from "./pic-detail.vue?vue&type=template&id=5a12fec6&scoped=true&"
import script from "./pic-detail.vue?vue&type=script&lang=js&"
export * from "./pic-detail.vue?vue&type=script&lang=js&"
import style0 from "./pic-detail.vue?vue&type=style&index=0&id=5a12fec6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a12fec6",
  null
  
)

export default component.exports